import { isInWorkflowPopover } from '../../helpers/matchers'

const phaseIndex = (position, state) =>
  state.phases.findIndex((phase) => phase.position === position)

/**
 * Builds an updated state object with the specific Phase's 'loading' state set to true.
 */
export function enablePhaseLoadingState(phase, prevState) {
  const currentPhase = { ...phase }
  const idx = phaseIndex(currentPhase.position, prevState)
  const phases = prevState.phases
  currentPhase.loading = true
  phases.splice(idx, 1, currentPhase)
  return { phases }
}

/**
 * Returns whether we need to show the "Start Workflow" button
 * based on the current state of Workflow.
 *
 * Note that in some cases, it will shown but subsequently disabled,
 * and in other cases it will be hidden altogether.
 */
export function shouldShowStartWorkflow(
  workflowLocation,
  workflowStarted,
  isTemplate,
  phaseCount
) {
  if (workflowStarted || isTemplate) {
    return false
  }

  if (isInWorkflowPopover(workflowLocation)) {
    if (phaseCount === 0) {
      return false
    }
  }

  return true
}

export default {
  enablePhaseLoadingState,
  shouldShowStartWorkflow,
}
